import React, { PropTypes } from 'react';
import { TextField } from 'material-ui';
import R from 'ramda';

const SearchBar = props => {
  const {
    value,
    onChangeFunc,
    isEditable,
    isSupplier,
  } = props;

  return (
    <div style={{ width: '100%', marginTop: '10px' }}>
      {
        !isEditable && !isSupplier ?
          <span/> :
          <TextField
            style={{ border: '1px solid #BDBDBD', width: '100%', borderRadius: '3px', maxHeight: '34px' }}
            inputStyle={{ fontSize: '14px', whiteSpace: 'pre-wrap', padding: '0px 3px' }}
            underlineShow={false}
            value={value}
            onChange={onChangeFunc}
            hintText={R.call(R.ifElse(
              R.equals(true),
                () => R.call(R.ifElse(
                  R.equals(true),
                    R.always('Search for a filename, location, or product...'),
                  R.always('Search for a filename...')
                ), isSupplier),
              R.always('Search for a location or product...')
            ), isEditable)}
            hintStyle={{ marginLeft: '5px', lineHeight: '34px', top: '-1px' }}
          />
      }
    </div>
  );
};

SearchBar.propTypes = {
  value: PropTypes.string,
  onChangeFunc: PropTypes.func,
  isEditable: PropTypes.bool,
  isSupplier: PropTypes.bool,
};

export default SearchBar;



// WEBPACK FOOTER //
// ./src/app/components/marketing-materials/search-bar.jsx